<template>
    <div class="Home">
        <div style="height:100px"></div>
        <div class="content-wrapper">
          <div>
            <button class="tab-button active" id="AzureImplementation" v-on:click="showTab('AzureImplementation')">
              Azure项目实施
            </button>
            <button class="tab-button" id="ADDomain" v-on:click="showTab('ADDomain')">
              AD域部署与升级
            </button>
            <button class="tab-button" id="Office365Deployment" v-on:click="showTab('Office365Deployment')">
              Office 365部署与迁移
            </button>
            <button class="tab-button" id="Microsoft365Security" v-on:click="showTab('Microsoft365Security')">
              Microsoft 365信息安全
            </button>
          </div>

          <!-- 标签内容 -->
          <div id="AzureImplementationTab" class="tab-content">
            <img src="../../resources/images/AzureImplementation/33.png" alt="Azure项目实施">
            <img src="../../resources/images/AzureImplementation/34.png" alt="Azure项目实施">
          </div>

          <div id="ADDomainTab" class="tab-content" style="display: none">
            <img src="../../resources/images/ADDomain/35.png" alt="AD域部署与升级">
            <img src="../../resources/images/ADDomain/36.png" alt="AD域部署与升级">
            <img src="../../resources/images/ADDomain/37.png" alt="AD域部署与升级">
            <img src="../../resources/images/ADDomain/38.png" alt="AD域部署与升级">
            <img src="../../resources/images/ADDomain/39.png" alt="AD域部署与升级">
            <img src="../../resources/images/ADDomain/40.png" alt="Azure项目实施">
            <img src="../../resources/images/ADDomain/41.png" alt="AD域部署与升级">
            <img src="../../resources/images/ADDomain/42.png" alt="AD域部署与升级">
            <img src="../../resources/images/ADDomain/43.png" alt="AD域部署与升级">
          </div>

          <div id="Office365DeploymentTab" class="tab-content" style="display: none">
            <img src="../../resources/images/Office365Deployment/44.png" alt="Office 365部署与迁移">
            <img src="../../resources/images/Office365Deployment/45.png" alt="Office 365部署与迁移">
            <img src="../../resources/images/Office365Deployment/46.png" alt="Office 365部署与迁移">
            <img src="../../resources/images/Office365Deployment/47.png" alt="Office 365部署与迁移">
            <img src="../../resources/images/Office365Deployment/48.png" alt="Office 365部署与迁移">
            <img src="../../resources/images/Office365Deployment/49.png" alt="Office 365部署与迁移">
          </div>

          <div id="Microsoft365SecurityTab" class="tab-content" style="display: none">
            <img src="../../resources/images/Microsoft365Security/50.png" alt="Microsoft 365信息安全">
            <img src="../../resources/images/Microsoft365Security/51.png" alt="Microsoft 365信息安全">
            <img src="../../resources/images/Microsoft365Security/52.png" alt="Microsoft 365信息安全">
            <img src="../../resources/images/Microsoft365Security/53.png" alt="Microsoft 365信息安全">
            <img src="../../resources/images/Microsoft365Security/54.png" alt="Microsoft 365信息安全">
            <img src="../../resources/images/Microsoft365Security/55.png" alt="Microsoft 365信息安全">
          </div>
        </div>
    </div>
</template>
<script>

export default {
  name: 'successCases',
  components: {
  },
  methods: {
    showTab(tabName){
        // 获取所有标签内容并隐藏它们
        var tabContent = document.getElementsByClassName("tab-content");
        for (var i = 0; i < tabContent.length; i++) {
            tabContent[i].style.display = "none";
        }

        // 获取所有标签按钮并删除它们的活动类
        var tabButton = document.getElementsByClassName("tab-button");
        for (var i = 0; i < tabButton.length; i++) {
            tabButton[i].classList.remove('active')
        }

        // 显示当前选定的标签并添加活动类到选定的按钮
        document.getElementById(tabName+"Tab").style.display = "block";
        document.getElementById(tabName).classList.add('active')
    }
  },
  mounted: function () {
    const hash = this.$route.hash;
    if (hash)
      this.showTab(hash.substring(1));
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/SuccessCases.vue